import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { DocumentTitle, PageHeader } from "components/common";
import { Alert, Row, Col } from "components/bootstrap";
import DataLakeBackendButton from "data-lake/data-lake-backend-config/DataLakeBackendButton";
import DataLakePageNavigation from "data-lake/components/DataLakePageNavigation";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import { DATA_LAKE_LICENSE_TITLE, DATA_LAKE_LICENSE_TEXT } from "data-lake/Constants";
import DocsHelper from "util/DocsHelper";
import BackendConfigOverview from "./BackendConfigOverview";
const DataLakeBackendPage = () => {
  const { t } = useTranslation("enterprise_data_lake");
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("backend_page.title") }, /* @__PURE__ */ React.createElement(DataLakePageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("backend_page.title"),
      documentationLink: {
        title: t("backend_page.documentation_link"),
        path: DocsHelper.PAGES.DATA_LAKE
      },
      actions: /* @__PURE__ */ React.createElement(DataLakeBackendButton, null)
    },
    /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "backend_page.intro_backend", components: { bold: /* @__PURE__ */ React.createElement("strong", null) } }), /* @__PURE__ */ React.createElement("br", null), t("backend_page.intro_single_backend"), /* @__PURE__ */ React.createElement("br", null), t("backend_page.intro_migration")),
    /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, t("backend_page.filesystem_warning"))
  ), /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      licenseSubject: LICENSE_SUBJECTS.archive,
      title: t(DATA_LAKE_LICENSE_TITLE),
      text: t(DATA_LAKE_LICENSE_TEXT),
      displayWarningContainer: true,
      bsStyle: "danger"
    }
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(BackendConfigOverview, null))));
};
export default DataLakeBackendPage;
